import Lottie from "lottie-react";
import { useState } from "react";
import arrowAnimation from "../../../lottie/arrow-lottie/Arrow_Lottie.json";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import Form from "react-bootstrap/Form";

import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import "./Vendor_Login.css";
import "react-phone-input-2/lib/style.css";

const Vendor_Login = ({ activeTab }) => {
  const navigate = useNavigate();
  const [isRegistering, setIsRegistering] = useState(false);
  const [formStep, setFormStep] = useState("register-step-1");
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(true);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const [licensePreview, setLicensePreview] = useState({
    name: "No file selected",
    url: null,
  });
  const [shopImagePreview, setShopImagePreview] = useState({ url: null });

  const cityOptions = [
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
  ];
  const stateOptions = [{ value: "maharashtra", label: "Maharashtra" }];
  const categoryOptions = [
    { value: "B2B", label: "B2B" },
    { value: "B2C", label: "B2C" },
  ];

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const handleOtpChange = (value, index) => {
    if (/[^0-9]/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-reg-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-reg-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleFileChange = (e, setPreview) => {
    const file = e.target.files[0];
    if (file) {
      setPreview({ name: file.name, url: URL.createObjectURL(file) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isRegistering) {
      setModalText("Login Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        navigate("/vendor-login-details");
      }, 3000);
    } else if (formStep === "register-step-1") {
      setFormStep("register-step-2");

      const scroller = document.querySelector(".scroll-form-body");
      if (scroller) scroller.scrollTop = 0;
    } else {
      setModalText("Account Created Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        setIsRegistering(false);
        setFormStep("register-step-1");
      }, 3000);
    }
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleSubmit}>
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Oll Type Services</p>
          </div>
          <img
            src="./assets/header/Oll-Type-Services.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {!isRegistering ? (
          <div className="login-fields-container">
            <Form.Group className="customer-input-group">
              <PhoneInput country={"in"} value={mobile} onChange={setMobile} />
              <Form.Label className="static-label">Mobile No*</Form.Label>
            </Form.Group>
            <Form.Group className="customer-input-group">
              <Form.Control type="text" placeholder=" " required />
              <Form.Label>Enter OTP</Form.Label>
            </Form.Group>
          </div>
        ) : (
          <div className="scroll-form-body">
            <div className="register-fields-container">
              {formStep === "register-step-1" ? (
                <div className="step-content">
                  <Form.Group className="customer-input-group">
                    <Form.Control type="text" placeholder=" " required />
                    <Form.Label>Full Name*</Form.Label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <PhoneInput
                      country={"in"}
                      value={mobile}
                      onChange={setMobile}
                    />
                    <Form.Label className="static-label">Mobile No*</Form.Label>
                  </Form.Group>

                  <div className="customer-otp-dotted-box">
                    <Form.Label className="customer-otp-label">
                      Enter OTP
                    </Form.Label>
                    <div className="customer-otp-slots">
                      {otp.map((digit, index) => (
                        <div key={index} className="customer-otp-slot">
                          <Form.Control
                            id={`otp-reg-${index}`}
                            type="text"
                            maxLength={1}
                            value={digit}
                            placeholder="●"
                            className="customer-otp-input"
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                          />
                          <hr className="customer-otp-line" />
                        </div>
                      ))}
                    </div>
                  </div>

                  <Form.Group className="customer-input-group">
                    <Form.Control type="text" placeholder=" " required />
                    <Form.Label>Adhar No*</Form.Label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Select
                      options={cityOptions}
                      styles={selectStyles}
                      placeholder=""
                    />
                    <Form.Label className="floating-label">City*</Form.Label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Select
                      options={stateOptions}
                      styles={selectStyles}
                      placeholder=""
                    />
                    <Form.Label className="floating-label">State*</Form.Label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Form.Control type="text" placeholder=" " required />
                    <Form.Label>Shop/ShowRoom Name*</Form.Label>
                  </Form.Group>

                  <Form.Group className="customer-input-group">
                    <Select
                      options={categoryOptions}
                      styles={selectStyles}
                      placeholder=""
                    />
                    <Form.Label className="floating-label">
                      Category*
                    </Form.Label>
                  </Form.Group>

                  <Form.Group className="upload-group">
                    <Form.Label className="upload-label">
                      Shopact Licence Image*
                    </Form.Label>
                    <div className="upload-box">
                      <Form.Control
                        type="file"
                        id="shopact-license-upload"
                        hidden
                        onChange={(e) => handleFileChange(e, setLicensePreview)}
                      />
                      <Form.Label
                        htmlFor="shopact-license-upload"
                        className="upload-display"
                      >
                        {licensePreview.url
                          ? "File Selected ✓"
                          : "Upload File...."}
                      </Form.Label>
                    </div>
                  </Form.Group>

                  <div className="view-document-container">
                    <div className="view-box">
                      {licensePreview.url ? (
                        <img
                          src={licensePreview.url}
                          alt="License"
                          className="document-img"
                        />
                      ) : (
                        <div className="no-preview-placeholder">
                          No preview available
                        </div>
                      )}
                    </div>
                  </div>

                  <Form.Group className="upload-group mt-4">
                    <Form.Label className="upload-label">
                      Shopact Images Upload*
                    </Form.Label>
                    <div className="upload-box">
                      <Form.Control
                        type="file"
                        id="shop-images-upload"
                        hidden
                        onChange={(e) =>
                          handleFileChange(e, setShopImagePreview)
                        }
                      />
                      <Form.Label
                        htmlFor="shop-images-upload"
                        className="upload-display"
                      >
                        {shopImagePreview.url
                          ? "File Selected ✓"
                          : "Upload File...."}
                      </Form.Label>
                    </div>
                  </Form.Group>

                  <div className="view-document-container">
                    <div className="view-box">
                      {shopImagePreview.url ? (
                        <img
                          src={shopImagePreview.url}
                          alt="Shop"
                          className="document-img"
                        />
                      ) : (
                        <div className="no-preview-placeholder">
                          No preview available
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="step-content">
                  <p className="docs-success-msg">
                    Documents have been signed successfully
                  </p>
                  <div className="container">
                    <div className="vendor-doc-card">
                      <span className="vendor-doc-title">MOU</span>
                      <button type="button" className="vendor-view-link">
                        View Document
                      </button>
                    </div>
                    <div className="vendor-doc-card">
                      <span className="vendor-doc-title">
                        View All Document
                      </span>
                    </div>
                  </div>
                  <Form.Group className="vendor-email-confirm mt-3">
                    <Form.Check
                      type="checkbox"
                      id="email-confirm-checkbox"
                      label="(You will receive documents via e-mail)"
                      checked={isEmailConfirmed}
                      onChange={(e) => setIsEmailConfirmed(e.target.checked)}
                    />
                  </Form.Group>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="customer-footer-actions">
          <div className="footer-content-block">
            <Common_Login_Button text="Register" />
            <div
              className="customer-toggle-footer"
              text={
                !isRegistering
                  ? "Login"
                  : formStep === "register-step-1"
                  ? "Next"
                  : "Submit"
              }
            >
              <div className="customer-toggle-footer">
                <span>
                  {!isRegistering
                    ? "Don't have an account?"
                    : "Already have an account?"}
                </span>
                <button
                  type="button"
                  className="customer-toggle-link"
                  onClick={() => {
                    setIsRegistering(!isRegistering);
                    setFormStep("register-step-1");
                  }}
                >
                  {!isRegistering ? "Create Account" : "Login Now"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
    </div>
  );
};

export default Vendor_Login;
